var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 14.611H0M0 1.39h17M0 8h17","stroke":"currentColor","strokeWidth":"1.193","fill":"none","fillRule":"evenodd"}));
}

HamburgerMenu.defaultProps = {"width":"17","height":"16"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
